export default "__VITE_ASSET__zhHU8mYu__"